var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgListPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "#EFEBFE",
    stroke: "#8D6CFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 13H29V15H15V13ZM15 21V19H29V21H15ZM12 12.5C12.3978 12.5 12.7794 12.658 13.0607 12.9393C13.342 13.2206 13.5 13.6022 13.5 14C13.5 14.3978 13.342 14.7794 13.0607 15.0607C12.7794 15.342 12.3978 15.5 12 15.5C11.6022 15.5 11.2206 15.342 10.9393 15.0607C10.658 14.7794 10.5 14.3978 10.5 14C10.5 13.6022 10.658 13.2206 10.9393 12.9393C11.2206 12.658 11.6022 12.5 12 12.5ZM12 18.5C12.3978 18.5 12.7794 18.658 13.0607 18.9393C13.342 19.2206 13.5 19.6022 13.5 20C13.5 20.3978 13.342 20.7794 13.0607 21.0607C12.7794 21.342 12.3978 21.5 12 21.5C11.6022 21.5 11.2206 21.342 10.9393 21.0607C10.658 20.7794 10.5 20.3978 10.5 20C10.5 19.6022 10.658 19.2206 10.9393 18.9393C11.2206 18.658 11.6022 18.5 12 18.5ZM15 27V25H29V27H15ZM12 24.5C12.3978 24.5 12.7794 24.658 13.0607 24.9393C13.342 25.2206 13.5 25.6022 13.5 26C13.5 26.3978 13.342 26.7794 13.0607 27.0607C12.7794 27.342 12.3978 27.5 12 27.5C11.6022 27.5 11.2206 27.342 10.9393 27.0607C10.658 26.7794 10.5 26.3978 10.5 26C10.5 25.6022 10.658 25.2206 10.9393 24.9393C11.2206 24.658 11.6022 24.5 12 24.5Z",
    fill: "#8D6CFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListPurple);
export default __webpack_public_path__ + "static/media/list-purple.db1ee07107a0c54618fd12778a3ba92a.svg";
export { ForwardRef as ReactComponent };